var render = function render(){var _vm=this,_c=_vm._self._c;return _c('piece-card',{attrs:{"title":"部门台账"}},[_c('div',{staticClass:"ledger-body"},[_c('TabsCard',{attrs:{"list":_vm.list},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}),_c('ScreenTable',{staticClass:"table-box",attrs:{"data":_vm.data,"columns":_vm.columns}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }